<kendo-dialog [width]="300"  title="Change Password"  (close)="this.onClose.emit()" >
    <form [formGroup]="formControls">
      <ng-container *ngIf="!this.userName">
        <div class="label-wrapper">
          <label [class.invalid]="!this.formControls.controls['userName'].valid">User name:</label>
        </div>
        <div class="input-wrapper">
          <input type="text" formControlName="userName" name="changeUserName" cpFocus autocomplete="off" autocorrect="off" autocapitalize="off" />
        </div>
      </ng-container>

      <div class="label-wrapper">
        <label [class.invalid]="!this.formControls.controls['oldPassword'].valid">Current password:</label>
      </div>
      <div class="input-wrapper">
        <input type="password" formControlName="oldPassword" name="changeOldPassword" cpFocus autocomplete="off" autocorrect="off" autocapitalize="off" />
      </div>

      <div class="label-wrapper">
        <label [class.invalid]="!this.formControls.controls['password'].valid">New password:</label>
      </div>
      <div class="input-wrapper">
        <input type="password"  formControlName="password" name="changeNewPassword" cpFocus autocomplete="off" autocorrect="off" autocapitalize="off" />

        <ul class="password-validators-list">
          <ng-container  *ngFor="let passwordValidator of activeValidators">
            <li>
              {{passwordValidator.message}}
              <i *ngIf="passwordValidator.isValid()" class="validator-ok" ></i>
            </li>
          </ng-container>
        </ul>
      </div>

      <div class="label-wrapper">
        <label [class.invalid]="!this.formControls.controls['confirmPassword'].valid">Repeat new password:</label>
      </div>
      <div class="input-wrapper">
        <input type="password" formControlName="confirmPassword"  name="changeConfirmPassword" cpFocus autocomplete="off" autocorrect="off" autocapitalize="off" />
      </div>

      <div class="error-wrapper" >
        <ng-container *ngIf="changePasswordErrorText">
          <span class="icon-error" ></span> <label>{{changePasswordErrorText }}</label>
        </ng-container>
      </div>
    </form>
  <kendo-dialog-actions>
    <button   class="cancel-button"  (click)="this.onClose.emit()">Cancel</button>
    <button   class="submit-button"  [disabled]="!this.formControls.valid || changePasswordInProgress" (click)="changePassword()">Submit</button>

  </kendo-dialog-actions>
</kendo-dialog>
